import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(
                `${api}/gescon/gerentes/pagamentos?status=${filtro.status}&dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}&classificacao=${filtro.classificacao}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(pagamentoId) {
        return axiosJwt
            .get(`${api}/gescon/gerentes/pagamentos/${pagamentoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPagamentoAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(
                `${api}/gescon/gerentes/pagamentos/anexos/${pagamentoAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAprovadores(idComprometimento) {
        let url = `${api}/gescon/gerentes/pagamentos/comprometimentos/${idComprometimento}/aprovadores`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexos(idComprometimento) {
        let url = `${api}/gescon/gerentes/pagamentos/comprometimentos/${idComprometimento}/anexos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexo(idComprometimento, comprometimentoAnexoId) {
        return axiosJwt
            .get(
                `${api}/gescon/gerentes/pagamentos/comprometimentos/${idComprometimento}/anexos/${comprometimentoAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(pagamentoId) {
        return axiosJwt
            .get(`${api}/gescon/gerentes/pagamentos/${pagamentoId}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    }
}
